import { render, staticRenderFns } from "./mobileMenus.vue?vue&type=template&id=8c0619ca&scoped=true"
import script from "./mobileMenus.vue?vue&type=script&lang=js"
export * from "./mobileMenus.vue?vue&type=script&lang=js"
import style0 from "./mobileMenus.vue?vue&type=style&index=0&id=8c0619ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0619ca",
  null
  
)

export default component.exports